import { combineReducers } from 'redux'
import { contractReducer } from './contractReducer'

const rootReducer = combineReducers({
    contractReducer
})

export default rootReducer